import React, { Component } from 'react';
import { translate } from 'react-i18next'
// import MetaTags from 'react-meta-tags';
import Helmet from 'react-helmet';
import JSON_DATA from './detail_th.json';
import JSON_DATA_EN from './detail_en.json';

const SITE_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:3000': 'https://www.moneytable.com';
const FACEBOOK_APP_ID = 'XXXXXXXXX';
const defaultImage = `${SITE_URL}/src/facebook_cover.jpg`;
const defaultTwitter = '@moneytable';
const defaultSep = ' | ';
const defaultTitle = 'MoneyTable';

class SetMetatags extends Component {

    constructor(props)
    {
        super(props);
        this.state = {}
    }

    getMetaTags( tagData , { title, description, image, contentType, twitter, noCrawl, published, updated, category, tags }, pathname )
    {
        const SiteTitle = title ? (title + defaultSep + defaultTitle) : tagData.SiteTitle;
        // const TagTitle       = tagData.TagTitle;
        const theDescription = tagData.TagDescription;
        const theImage = image ? image : defaultImage;

        const metaTags = [
            { itemprop: 'name', content: SiteTitle },
            { itemprop: 'description', content: theDescription },
            { itemprop: 'image', content: theImage },
            { name: 'description', content: theDescription },
            { name: 'twitter:card', content: 'summary_large_image' },
            { name: 'twitter:site', content: defaultTwitter },
            { name: 'twitter:title', content: SiteTitle },
            { name: 'twitter:description', content: theDescription },
            { name: 'twitter:creator', content: twitter || defaultTwitter },
            { name: 'twitter:image:src', content: theImage },
            { property: 'og:title', content: SiteTitle },
            { property: 'og:type', content: contentType || 'website' },
            { property: 'og:url', content: SITE_URL + pathname },
            { property: 'og:image', content: theImage },
            { property: 'og:description', content: theDescription },
            { property: 'og:site_name', content: SiteTitle },
            { property: 'fb:app_id', content: FACEBOOK_APP_ID }
        ];

        if (noCrawl) {
            metaTags.push({ name: 'robots', content: 'noindex, nofollow' });
        }

        if (published) {
            metaTags.push({ name: 'article:published_time', content: published });
        }
        if (updated) {
            metaTags.push({ name: 'article:modified_time', content: updated });
        }
        if (category) {
            metaTags.push({ name: 'article:section', content: category });
        }
        if (tags) {
            metaTags.push({ name: 'article:tag', content: tags });
        }

        return metaTags;
    }
    
    render() {
        
        const { i18n , ...rest} = this.props;

        let is_page  = this.props.currentpage.toString().replace('/en', '')
        let tagData = "";
        switch (i18n.language) {
            case 'en':
                tagData = (JSON_DATA_EN[is_page])?JSON_DATA_EN[is_page]:JSON_DATA_EN['/home'];
                break;

            default:
                tagData = (JSON_DATA[is_page])?JSON_DATA[is_page]:JSON_DATA['/home'];
                break;
        }

        return (
            <Helmet
                title={rest.title ? (rest.title + defaultSep + defaultTitle) : tagData.SiteTitle}
                link={[
                    {
                        rel: 'canonical',
                        href: SITE_URL + this.props.currentpage
                    }
                ]}
                meta={this.getMetaTags(tagData, rest, this.props.currentpage)}
            />
        );
    }

}

export default translate('translations')(SetMetatags)


// WEBPACK FOOTER //
// ./src/metatag/index.jsx